import React from 'react'
import { Document, Page, Text, StyleSheet, View } from '@react-pdf/renderer'
import dayjs from 'dayjs'
const WHITE_COLOR = '#FFFFFF'
const ODD_ROW_COLOR = '#F0F4FF'
const MONTH_TOTAL_COLOR = '#C5CAE9'
const YEAR_TOTAL_COLOR = '#9FA8DA'
const GRAND_TOTAL_COLOR = YEAR_TOTAL_COLOR
const styles = StyleSheet.create({
  page: {
    paddingTop: 50,
    paddingBottom: 50,
    paddingHorizontal: 50
  },
  footer: {
    position: 'absolute',
    bottom: 25,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 10,
    color: '#666',
    fontFamily: 'Roboto'
  },
  theaderAccounting: {
    flexBasis: 100,
    fontFamily: 'Roboto',
    marginTop: 20,
    color: 'black',
    fontSize: 12,
    fontWeight: 600,
    padding: 10.5,
    alignContent: 'left',
    borderColor: '#eceeef',
    borderTopWidth: 1,
    borderBottomWidth: 1
  },
  theaderAccounting2: {
    flexBasis: 220,
    fontFamily: 'Roboto',
    marginTop: 20,
    color: 'black',
    fontSize: 12,
    fontWeight: 600,
    padding: 10.5,
    alignContent: 'left',
    borderColor: '#eceeef',
    borderTopWidth: 1,
    borderBottomWidth: 1
  },
  reportTitleSmall: {
    fontFamily: 'Roboto',
    fontWeight: 300,
    fontSize: 28,
    textAlign: 'center'
  },
  tbodyAccounting2: { flexBasis: 220, textAlign: 'left', fontSize: 10, padding: 10.5 },
  totalAccounting: { fontSize: 10, padding: 10.5, flex: 1.5 },
  tbodyAccounting: { textAlign: 'left', flexBasis: 100, fontSize: 10, padding: 4, paddingLeft: 10 },
  tbodyAccounting2: { flexBasis: 220, textAlign: 'left', fontSize: 10, padding: 4, paddingLeft: 10 },
  tbodyAccountingRight: { textAlign: 'right', flexBasis: 100, fontSize: 10, padding: 4, paddingRight: 10 },
  totalRowBase: {
    flexDirection: 'row',
    borderTop: '1px solid #BBBBBB',
    paddingVertical: 4,
    fontWeight: 'bold'
  },
  monthTotalRow: {
    backgroundColor: MONTH_TOTAL_COLOR,
    borderTop: '1px solid #AAAAAA'
  },
  yearTotalRow: {
    backgroundColor: YEAR_TOTAL_COLOR,
    borderTop: '1px solid #999999'
  },
  grandTotalRow: {
    backgroundColor: GRAND_TOTAL_COLOR,
    borderTop: '2px solid #666666'
  },
  totalLabel: {
    flexBasis: 420,
    textAlign: 'right',
    fontSize: 10,
    padding: 4,
    fontWeight: 'bold',
    paddingRight: 10
  },
  totalAmount: {
    textAlign: 'right',
    flexBasis: 100,
    fontSize: 10,
    padding: 4,
    fontWeight: 'bold',
    paddingRight: 10
  },
  totalAmountProfit: {
    textAlign: 'right',
    flexBasis: 200,
    fontSize: 10,
    padding: 4,
    fontWeight: 'bold',
    paddingRight: 10
  }
})

const AccountingPDF = ({ dataSet, columns }) => {
  const formatAmount = (val) => {
    const num = parseFloat(val)
    return isNaN(num) ? '0.00 €' : num.toFixed(2) + ' €'
  }

  const formatDate = (value) => {
    if (!value) return ''
    const dateObj = dayjs(value, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD/MM/YYYY'])
    return dateObj.isValid() ? dateObj.format('DD/MM/YYYY') : ''
  }

  const getTotalCreditPeriod = (lines) => lines.reduce((sum, line) => sum + (line.credit || 0), 0)
  const getTotalDebitPeriod = (lines) => lines.reduce((sum, line) => sum + (line.debit || 0), 0)
  const getTotalCreditYear = (year) =>
    year.periodYearMonth.reduce((sum, month) => sum + getTotalCreditPeriod(month.lines), 0)
  const getTotalDebitYear = (year) =>
    year.periodYearMonth.reduce((sum, month) => sum + getTotalDebitPeriod(month.lines), 0)
  const getTotalCredit = (dataSet) => dataSet.reduce((sum, year) => sum + getTotalCreditYear(year), 0)
  const getTotalDebit = (dataSet) => dataSet.reduce((sum, year) => sum + getTotalDebitYear(year), 0)

  let lineCounter = 0
  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <Text style={styles.reportTitleSmall}>Comptabilité générale</Text>
        <View style={{ flexDirection: 'row', marginTop: 20 }} fixed>
          <Text style={styles.theaderAccounting}>{columns[0].label}</Text>
          <Text style={styles.theaderAccounting}>{columns[1].label}</Text>
          <Text style={styles.theaderAccounting}>{columns[2].label}</Text>
          <Text style={styles.theaderAccounting2}>{columns[3].label}</Text>
          <Text style={styles.theaderAccounting}>{columns[4].label}</Text>
          <Text style={styles.theaderAccounting}>{columns[5].label}</Text>
        </View>
        {dataSet.map((year) => {
          let yearRendered = false
          const monthViews = year.periodYearMonth
            .map((month) => {
              let monthRendered = false
              const lineViews = month.lines
                .map((line, lineIndex) => {
                  const isStripe = lineCounter % 2 === 0
                  const rowBg = isStripe ? WHITE_COLOR : ODD_ROW_COLOR
                  lineCounter++

                  return (
                    <View
                      style={{ flexDirection: 'row', backgroundColor: rowBg }}
                      key={`${month.yearMonth}-${line.id || lineIndex}`}
                    >
                      <Text style={styles.tbodyAccounting}>{!yearRendered ? year.periodYear : ''}</Text>
                      <Text style={styles.tbodyAccounting}>{!monthRendered ? month.yearMonth : ''}</Text>
                      <Text style={styles.tbodyAccounting}>{line.date ? formatDate(line.date) : ''}</Text>
                      <Text style={styles.tbodyAccounting2}>{line.description || ''}</Text>
                      <Text style={styles.tbodyAccountingRight}>{line.credit ? formatAmount(line.credit) : ''}</Text>
                      <Text style={styles.tbodyAccountingRight}>{line.debit ? formatAmount(line.debit) : ''}</Text>

                      {(() => {
                        if (!yearRendered) yearRendered = true
                        if (!monthRendered) monthRendered = true
                        return null
                      })()}
                    </View>
                  )
                })
                .concat(
                  <View style={[styles.totalRowBase, styles.monthTotalRow]} key={`month-total-${month.yearMonth}`}>
                    <Text style={styles.totalLabel}>Total {month.yearMonth}:</Text>
                    <Text style={styles.totalAmount}>{formatAmount(getTotalCreditPeriod(month.lines))}</Text>
                    <Text style={styles.totalAmount}>{formatAmount(getTotalDebitPeriod(month.lines))}</Text>
                  </View>
                )

              return lineViews
            })

            .flat()
            .concat(
              <View style={[styles.totalRowBase, styles.yearTotalRow]} key={`year-total-${year.periodYear}`}>
                <Text style={styles.totalLabel}>Total {year.periodYear}:</Text>
                <Text style={styles.totalAmount}>{formatAmount(getTotalCreditYear(year))}</Text>
                <Text style={styles.totalAmount}>{formatAmount(getTotalDebitYear(year))}</Text>
              </View>
            )

          return monthViews
        })}
        <View style={[styles.totalRowBase, styles.grandTotalRow, { marginTop: 10 }]}>
          <Text style={styles.totalLabel}>Grand Total:</Text>
          <Text style={styles.totalAmount}>{formatAmount(getTotalCredit(dataSet))}</Text>
          <Text style={styles.totalAmount}>{formatAmount(getTotalDebit(dataSet))}</Text>
        </View>

        <View style={[styles.totalRowBase, styles.grandTotalRow]}>
          <Text style={styles.totalLabel}>Bénéfice:</Text>
          <Text style={styles.totalAmountProfit}>{formatAmount(getTotalCredit(dataSet) - getTotalDebit(dataSet))}</Text>
        </View>
        <Text
          style={styles.footer}
          fixed
          render={({ pageNumber, totalPages }) => `Test Page ${pageNumber} sur ${totalPages}`}
        />
      </Page>
    </Document>
  )
}
export default AccountingPDF
